"use client"

import { useState, useEffect } from "react"
import axios from "axios"
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const AddPurchase = () => {
  const [formData, setFormData] = useState({
    product_master_code: '',
    vendor_name: '',
    product_name: '',
    category_name: '',
    product_material: '',
    product_color: '',
    quantity_purchased: '',
    purchase_price_per_unit: '',
    purchase_date: new Date().toISOString().split('T')[0],// Set default to today's date
    invoice_number: '',
  })

  const [categories, setCategories] = useState([])
  const [material, setMaterial] = useState([])
  const [colors, setColors] = useState([])
  const [vendors, setVendors] = useState([])
  const [products, setProducts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    fetchCategories()
    fetchMaterials()
    fetchColors()
    fetchVendors()
    fetchProducts()
  }, [])

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-product-categories`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setCategories(response.data.data)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch categories")
    }
  }

  const fetchMaterials = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/pixel-get-product-material`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setMaterial(response.data.data)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch materials")
    }
  }
  const fetchVendors = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/pixel-get-all-vendor-email-name`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setVendors(response.data.data)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch vendors")
    }
  }

  const fetchColors = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/pixel-get-product-colors`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setColors(response.data.data)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch colors")
    }
  }

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-pixel-products`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setProducts(response.data.data)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch products")
    } finally {
      setIsLoading(false)
    }
  }


  // ✅ Updated handleProductSelect to support react-select
  const handleProductSelect = (selectedOption) => {  // Highlighted new function argument
    const selectedProduct = products.find(p => p.product_code === selectedOption?.value)
    if (selectedProduct) {
      setFormData({
        ...formData,
        product_master_code: selectedProduct.product_code,
        product_name: selectedProduct.product_name,
        category_name: selectedProduct.category_name,
        product_material: selectedProduct.product_material
      })
    } else {
      setFormData({
        ...formData,
        product_master_code: '',
        product_name: '',
        category_name: '',
        product_material: '',

      })
    }

  }


  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    console.log(formData)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setError(null)
    setSuccess(false)

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/api/pixel-add-purchase-product`,
        formData,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.data) {
        setFormData({
          product_master_code: '',
          vendor_name: '',
          product_name: '',
          category_name: '',
          product_material: '',
          product_color: '',
          quantity_purchased: '',
          purchase_price_per_unit: '',
          purchase_date: new Date().toISOString().split('T')[0],
          invoice_number: '',
        })
        // setSuccess(true)
        toast.success("Purchase added successfully!");

      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to add purchase");

    } finally {
      setIsSubmitting(false)
    }
  }
  const productOptions = products.map((product) => ({
    value: product.product_code,
    label: `${product.product_code} - ${product.product_name}`,
  }));
  const colorOptions = colors.map((color) => ({
    value: color.product_color,
    label: color.product_color,
  }));
  const vendorOptions = vendors.map((vendor) => ({
    value: vendor.full_name,  // or vendor.full_name, based on what you want to store
    label: `${vendor.full_name} (${vendor.email})`,
  }));



  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h1 className="text-2xl font-semibold text-gray-900 mb-6">Add Purchase</h1>

            {error && (
              <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-600">
                {error}
              </div>
            )}

            {success && (
              <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg text-green-600">
                Purchase added successfully!
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Product Code
                  </label>

                  {/* <select
                  name="product_master_code"
                  value={formData.product_master_code}
                  onChange={handleProductSelect}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  required
                  disabled={isSubmitting}
                >
                  <option value="">Select Product</option>
                  {products.map((product) => (
                    <option key={product.id} value={product.product_code}>
                      {product.product_code} - {product.product_name}
                    </option>
                  ))}
                </select> */}

                  <Select
                    name="product_master_code"
                    options={productOptions}
                    value={productOptions.find(
                      (option) => option.value === formData.product_master_code
                    ) || null}
                    onChange={(selectedOption) => { handleProductSelect(selectedOption); }}//handlePriceSet(formData.product_color)
                    isDisabled={isSubmitting}
                    placeholder="Search/Select Product"
                    isClearable={true}
                    className="w-full"
                    classNamePrefix="react-select"
                  />
                </div>




                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Product Name
                  </label>
                  <input
                    type="text"
                    name="product_name"
                    value={formData.product_name}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Category
                  </label>
                  <input
                    type="text"
                    name="category_name"
                    value={formData.category_name}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Material
                  </label>
                  <input
                    type="text"
                    name="product_material"
                    value={formData.product_material}
                    readOnly
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Color
                  </label>
                  <Select
                    name="product_color"
                    options={colorOptions}
                    value={colorOptions.find(
                      (option) => option.value === formData.product_color
                    ) || null}
                    onChange={(selectedOption) => {

                      handleChange({
                        target: { name: "product_color", value: selectedOption?.value || "" }
                      })//; handlePriceSet(selectedOption?.value || "")
                    }}
                    isDisabled={isSubmitting}
                    placeholder="Select color"
                    isClearable={true}
                    className="w-full"
                    classNamePrefix="react-select"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Quantity
                  </label>
                  <input
                    type="number"
                    name="quantity_purchased"
                    value={formData.quantity_purchased}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                    required
                    min="0"
                    disabled={isSubmitting}
                  />
                </div>
                {/* add vendor */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vendor
                  </label>
                  <Select
                    name="vendor_name"
                    options={vendorOptions}
                    value={vendorOptions.find((option) => option.value === formData.vendor_name) || null}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: { name: "vendor_name", value: selectedOption?.value || "" },
                      })
                    }
                    placeholder="Select Vendor"
                    isClearable={true}
                    className="w-full"
                    classNamePrefix="react-select"
                  />

                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Price Per Unit
                  </label>
                  <input
                    type="number"
                    name="purchase_price_per_unit"
                    value={formData.purchase_price_per_unit}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                    required
                    min="0"
                    step="0.01"
                    disabled={isSubmitting}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Purchase Date
                  </label>
                  <input
                    type="date"
                    name="purchase_date"
                    value={formData.purchase_date}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                    required
                    disabled={isSubmitting}
                  />
                </div>
                {/* invoice_number */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Invoice Number
                  </label>
                  <input
                    type="text"
                    name="invoice_number"
                    value={formData.invoice_number}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                    required

                    disabled={isSubmitting}
                  />
                </div>
              </div>

              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => window.location.href = '/all-purchases'}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Adding..." : "Add Purchase"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddPurchase
